<div class="player-hls-time-control-container">
  <div class="player-hls-time-control__timestamp">
    <span #hlsTime class="player-hls-time-control__hls-time"></span>
  </div>
</div>
